<script setup lang="ts">
import { computed, useAttrs } from "vue"

// inheritAttrs=false: attrs (min, max, step, aria-describedby, name тощо) прокидаємо
// на нативний input через v-bind="attrs" явно; aria-invalid обчислюється окремо.
defineOptions({ inheritAttrs: false })

const props = defineProps<{
  unit?: string
  id?: string
  disabled?: boolean
  invalid?: boolean
  placeholder?: string
}>()

const modelValue = defineModel<string>({ default: "" })
const attrs = useAttrs()

/** Error-стан = проп `invalid` АБО зовнішній aria-invalid (string/boolean truthy). */
const ariaInvalid = computed<true | undefined>(() => {
  if (props.invalid) return true
  const a = attrs["aria-invalid"]
  return a === true || a === "" || a === "true" ? true : undefined
})

function onInput(event: Event) {
  modelValue.value = (event.target as HTMLInputElement).value
}
</script>

<template>
  <div
    data-slot="number-field"
    class="relative flex items-center"
  >
    <input
      v-bind="attrs"
      type="number"
      inputmode="numeric"
      data-slot="number-field-input"
      :id="id"
      :value="modelValue"
      :disabled="disabled"
      :placeholder="placeholder"
      :aria-invalid="ariaInvalid"
      :data-invalid="ariaInvalid"
      class="file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
      :class="{ 'pr-10': unit }"
      @input="onInput"
    >
    <span
      v-if="unit"
      aria-hidden="true"
      class="pointer-events-none absolute right-3 text-sm text-muted-foreground"
    >{{ unit }}</span>
  </div>
</template>
